export default __webpack_public_path__ + "static/media/product-3.c048ad5c.jpg";